import React, {useEffect} from 'react';
import {PcOtherBenefits} from './pc/PcOtherBenefits'; // 注意这里是默认导入
import {MobileOtherBenefits} from './mobile/MobileOtherBenefits'; // 注意这里是默认导入

function OtherBenefits({isMobile, clicked, clickNext, ...props}) { // 接收 isMobile props
    // 确保 clickNext 和 clickPrev props 被传递，如果未提供则使用空函数作为默认值
    const commonProps = {
        ...props,
        clickNext: clickNext || (() => {}),
        clickPrev: props.clickPrev || (() => {})
    };

    useEffect(() => {
        if (clicked) {
            clickNext("");
        }
    }, [clicked]);

    if (isMobile) { // 根据 isMobile props 条件渲染
        return <MobileOtherBenefits {...commonProps} />;
    } else {
        return <PcOtherBenefits {...commonProps} />;
    }
}

export default OtherBenefits;